import React from 'react';
import { CFooter } from '@coreui/react';
import { withFirebase } from 'src/views/firebase';

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        <a href="https://mieros.org" target="_blank" rel="noopener noreferrer">
          MiEROS
        </a>
        <span className="ms-1">&copy; 2026.</span>
      </div>
      {/* <div className="ms-auto">
        <span className="me-1">Powered by</span>
        <a href="https://synergysemantics.com" target="_blank" rel="noopener noreferrer">
          Synergy Semantics
        </a>
      </div> */}
    </CFooter>
  );
};

export default withFirebase(React.memo(AppFooter));
